import styled from "styled-components";
import { CSSVars } from "@/styles/styles.config";

export const StyledSection = styled.section`
  background: ${CSSVars.white};
  padding: 60px 0 70px;
  overflow: hidden;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 80px 0 90px;
  }
  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 100px 0 110px;
  }

  h2 {
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 28px;
    line-height: 1.2;
    letter-spacing: -0.02em;
    color: ${CSSVars.black};
    text-align: center;
    margin: 0 20px 36px;
    max-width: 860px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 36px;
      margin: 0 auto 44px;
    }
    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      font-size: 44px;
      margin: 0 auto 56px;
    }
  }

  .marquee {
    position: relative;
    width: 100%;
    overflow: hidden;
    mask-image: linear-gradient(
      to right,
      transparent 0,
      black 80px,
      black calc(100% - 80px),
      transparent 100%
    );
    -webkit-mask-image: linear-gradient(
      to right,
      transparent 0,
      black 80px,
      black calc(100% - 80px),
      transparent 100%
    );
  }

  .track {
    display: flex;
    width: max-content;
    gap: 16px;
    animation: scrollPlatforms 40s linear infinite;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      gap: 20px;
    }

    &:hover {
      animation-play-state: paused;
    }
  }

  @keyframes scrollPlatforms {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-50%);
    }
  }

  .tile {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 104px;
    height: 104px;
    background: ${CSSVars.white};
    border: 1px solid ${CSSVars.gray100};
    border-radius: 18px;
    text-decoration: none;
    color: inherit;
    transition: transform 0.2s ease, box-shadow 0.2s ease,
      border-color 0.2s ease;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      width: 116px;
      height: 116px;
      border-radius: 20px;
    }

    &:hover {
      transform: translateY(-3px);
      border-color: ${CSSVars.gray200};
      box-shadow: 0 10px 22px rgba(16, 24, 40, 0.08);
    }

    .icon {
      width: 44px;
      height: 44px;
      transition: transform 0.2s ease;

      @media screen and (min-width: ${CSSVars.breakpointMD}) {
        width: 48px;
        height: 48px;
      }
    }

    &:hover .icon {
      transform: scale(1.06);
    }
  }

  .view-all {
    display: flex;
    justify-content: center;
    margin-top: 36px;

    a {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font-family: ${CSSVars.primaryFont};
      font-weight: 600;
      font-size: 15px;
      color: ${CSSVars.blue500};
      text-decoration: none;
      padding: 10px 14px;
      border-radius: 999px;
      transition: background 0.2s ease;

      &:hover {
        background: rgba(76, 79, 255, 0.08);
      }

      .icon {
        transition: transform 0.2s ease;
      }

      &:hover .icon {
        transform: translateX(3px);
      }
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .track {
      animation: none;
      flex-wrap: wrap;
      width: 100%;
      justify-content: center;
      gap: 12px;
      padding: 0 20px;
    }

    .marquee {
      mask-image: none;
      -webkit-mask-image: none;
    }
  }
`;
